export function inchesToPixels(value){
	return value*72;
}